<template lang="pug">
.insights-ranking-widget-item
  .details
    .info
      .main
        .percentage {{ valuePercentage }}
        .name(
          ref="rankingItemName"
          v-tooltip="tooltipOptions"
          :title="item.name"
        ) {{ item.name }}
        slot(
          v-if="showPostfix"
          name="ranking-item-name-postfix"
        )
      InsightsRankingProgressBar(
        :item="item"
        :type="type"
        :max="max"
      )
    .time(v-if="!collapsed")
      | {{ timeSpent }}
    .activity(
      v-if="hasActivity && !collapsed"
      :class="activityClasses"
    )
      | {{ activityPercentage }}
</template>

<script>
import { formatDuration } from '~/utils/time_utils';
import { activityClasses } from '~/utils/insights_utils';

import InsightsRankingProgressBar from './InsightsRankingProgressBar.vue';

export default {
  name: 'InsightsRankingItem',
  components: {
    InsightsRankingProgressBar,
  },
  props: {
    max: {
      type: Number,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    collapsed: {
      type: Boolean,
      default: false,
    },
    widgetWidth: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    tooltipOptions: false,
  }),
  computed: {
    timeSpent() {
      return formatDuration(this.item.tracked, { showSeconds: 'never' });
    },
    activity() {
      return this.item.activity;
    },
    hasActivity() {
      return this.activity !== undefined;
    },
    activityPercentage() {
      return `${Math.round(this.activity || 0 * 100)}%`;
    },
    valuePercentage() {
      const percentage = this.item.value * 100;

      return `${+percentage.toFixed(1)}%`;
    },
    activityClasses() {
      return activityClasses(this.activity);
    },
    showPostfix() {
      return ['url', 'application'].includes(this.item.type);
    },
  },
  watch: {
    widgetWidth() {
      this.setTooltip();
    },
  },
  mounted() {
    this.setTooltip();
  },
  methods: {
    setTooltip() {
      this.tooltipOptions = this.isNameOverflown() ? Object.freeze({ trigger: 'hover' }) : false;
    },
    isNameOverflown() {
      return this.$refs.rankingItemName.scrollWidth > this.$refs.rankingItemName.clientWidth;
    },
  },
};
</script>
